import { Product } from '@precoa/calculator-sdk'

export type InsuranceProduct = {
	name: string
	carrier: 'NGL'
	code: Product
}

export const insuranceProducts: InsuranceProduct[] = [
	{ name: 'Product1', carrier: 'NGL', code: Product.Standard },
	{ name: 'Product2', carrier: 'NGL', code: Product.P100 },
	{ name: 'Product3', carrier: 'NGL', code: Product.P100 },
	{ name: 'Product6', carrier: 'NGL', code: Product.P100 },
	{ name: 'Product7', carrier: 'NGL', code: Product.P100 },
	{ name: 'Product7 - X Series', carrier: 'NGL', code: Product.P135 },
	{ name: 'Product7 - X Series Dynamic', carrier: 'NGL', code: Product.P135 },
	{ name: 'Product4', carrier: 'NGL', code: Product.P100 },
	{ name: 'Product5', carrier: 'NGL', code: Product.P100 },
	{ name: 'Product8', carrier: 'NGL', code: Product.P100 },
	{ name: 'Product8 - X Series', carrier: 'NGL', code: Product.P135 },
	{ name: 'Product8 - X Series Dynamic', carrier: 'NGL', code: Product.P135 },
	{ name: 'Product9', carrier: 'NGL', code: Product.P100 },
	{ name: 'Product9 - X Series', carrier: 'NGL', code: Product.P135 },
	{ name: 'Product9 - X Series Dynamic', carrier: 'NGL', code: Product.P135 },
	{ name: 'Product10', carrier: 'NGL', code: Product.P100 },
	{ name: 'Product10 - X Series', carrier: 'NGL', code: Product.P135 },
	{ name: 'Product10 - X Series Dynamic', carrier: 'NGL', code: Product.P135 },
	{ name: 'Product11', carrier: 'NGL', code: Product.P100 },
	{ name: 'NGL Series 4 - NJ', carrier: 'NGL', code: Product.P100 },
	{ name: 'P100CS', carrier: 'NGL', code: Product.P100CS },
	{ name: 'Variable Growth Commissions', carrier: 'NGL', code: Product.PG },

	// Not implemented in rate calc
	// { name: 'NGL Series 23', carrier: 'NGL', code: '23S' },
	// { name: 'PLC100', carrier: 'NGL', code: 'PLC100' },
]
